// Environment configuration loader
// Loads configuration ONLY from window.APP_CONFIG which is set by config.js (or config.local.js in dev)

const loadConfig = () => {
  // Check if we have window.APP_CONFIG with actual values
  if (window.APP_CONFIG && 
      window.APP_CONFIG.auth?.clientId && 
      window.APP_CONFIG.auth?.clientId !== '') {
    console.log('✅ Configuration loaded successfully:', {
      hasClientId: !!window.APP_CONFIG.auth.clientId,
      hasAuthority: !!window.APP_CONFIG.auth.authority,
      hasEnvironmentId: !!window.APP_CONFIG.copilot.environmentId,
      hasAgentId: !!window.APP_CONFIG.copilot.agentIdentifier,
      source: 'window.APP_CONFIG'
    });
    
    return window.APP_CONFIG;
  }
  
  // No valid configuration found
  console.error('❌ No configuration found! Environment variables are required.');
  console.error('Local dev: Make sure config.local.js is loaded and .env file exists');
  console.error('Azure: Set variables in Static Web App Configuration');
  
  return {
    auth: { clientId: '', authority: '' },
    copilot: { environmentId: '', agentIdentifier: '' }
  };
};

// Load and set the configuration
window.APP_CONFIG = loadConfig();

// Validate configuration
if (!window.APP_CONFIG?.auth?.clientId || 
    !window.APP_CONFIG?.auth?.authority || 
    !window.APP_CONFIG?.copilot?.environmentId || 
    !window.APP_CONFIG?.copilot?.agentIdentifier) {
  console.error('❌ Missing required configuration values!');
  console.error('Make sure environment variables are set:');
  console.error('  - Local: .env file with CLIENT_ID, AUTH_AUTHORITY, ENVIRONMENT_ID, AGENT_IDENTIFIER');
  console.error('  - Azure: Static Web Apps Configuration with the same variables');
  
  // Show error message to user
  document.addEventListener('DOMContentLoaded', () => {
    const chatSection = document.getElementById('chatSection');
    if (chatSection) {
      chatSection.innerHTML = `
        <div style="padding: 2rem; text-align: center;">
          <h2 style="color: #ef4444;">⚠️ Configuration Error</h2>
          <p style="color: #666; margin: 1rem 0;">
            Required environment variables are not configured.
          </p>
          <p style="color: #666;">
            Please contact your administrator to set up the application configuration.
          </p>
        </div>
      `;
      chatSection.classList.remove('hidden');
    }
  });
}

export default window.APP_CONFIG;

